import React from 'react';
import Logo from "../assets/belleepoque_logo.png";

const LocalBusinessSchema = () => {
  const localBusinessData = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    "name": "BelleEpoque",
    "image": {Logo},
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Centro Comercial Figueira Shopping FozCenter Loja 12/13",
      "addressLocality": " Figueira da Foz",
      "postalCode": "3080-036",
      "addressCountry": "PT"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.1488191",
      "longitude": "-8.856751,17"
    },
    "url": "https://belle-epoque.pt/",
    "telephone": "+351935945664",
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessData) }}
    />
  );
};

export default LocalBusinessSchema;